(function (FragranceFinder) {
  'use strict';

  FragranceFinder.STORAGE_KEY = 'pdm_ff_state';
  FragranceFinder.STATE_VERSION = 1;
  FragranceFinder.EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  FragranceFinder.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

  const STORAGE_KEY = FragranceFinder.STORAGE_KEY;
  const mobileMediaQuery = FragranceFinder.mobileMediaQuery;

  FragranceFinder.parseJson = function parseJson(element, fallback) {
    if (!element) return fallback;
    try { return JSON.parse(element.textContent); } catch (error) { return fallback; }
  };

  FragranceFinder.normalizeUrl = function normalizeUrl(url) {
    url = String(url == null ? '' : url).trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  };

  FragranceFinder.pickUrl = function pickUrl(desktopUrl, mobileUrl) {
    const url = mobileMediaQuery.matches ? (mobileUrl || desktopUrl) : (desktopUrl || mobileUrl);
    return FragranceFinder.normalizeUrl(url);
  };

  FragranceFinder.escapeHtml = function escapeHtml(string) {
    return String(string == null ? '' : string)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  FragranceFinder.renderRichTextNode = function renderRichTextNode(node) {
    if (!node || typeof node !== 'object') return '';
    const children = Array.isArray(node.children)
      ? node.children.map(FragranceFinder.renderRichTextNode).join('')
      : '';

    switch (node.type) {
      case 'root':
        return children;
      case 'paragraph':
        return '<p>' + children + '</p>';
      case 'heading':
        return '<h' + Math.min(Math.max(Number(node.level) || 2, 1), 6) + '>' + children + '</h' + Math.min(Math.max(Number(node.level) || 2, 1), 6) + '>';
      case 'list':
        return (node.listType === 'ordered' ? '<ol>' : '<ul>') + children + (node.listType === 'ordered' ? '</ol>' : '</ul>');
      case 'list-item':
        return '<li>' + children + '</li>';
      case 'link':
        return '<a href="' + FragranceFinder.escapeHtml(node.url || '#') + '">' + children + '</a>';
      case 'text': {
        let text = FragranceFinder.escapeHtml(node.value || '');
        if (node.bold) text = '<strong>' + text + '</strong>';
        if (node.italic) text = '<em>' + text + '</em>';
        return text;
      }
      default:
        return children;
    }
  };

  FragranceFinder.normalizeRichText = function normalizeRichText(value) {
    if (value == null || value === '') return '';
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!trimmed || trimmed.charAt(0) !== '{') return value;
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && parsed.type === 'root') return FragranceFinder.renderRichTextNode(parsed);
    } catch (error) {}
    return value;
  };

  FragranceFinder.buildNoteSteps = function buildNoteSteps(product, translations) {
    translations = translations || {};
    const list = (product && product.notes) || [];
    const empty = translations.notesEmpty || '-';
    function getNoteValue(index) {
      const noteValue = list[index];
      return (typeof noteValue === 'string' && noteValue.trim()) ? noteValue.trim() : empty;
    }
    return [
      { label: translations.notesTop || '', values: getNoteValue(0) },
      { label: translations.notesHeart || '', values: getNoteValue(1) },
      { label: translations.notesBase || '', values: getNoteValue(2) }
    ];
  };

  FragranceFinder.getTranslations = function getTranslations(settings) {
    return (settings && settings.i18n) || {};
  };

  FragranceFinder.getSettingText = function getSettingText(settings, settingKey, translationKey) {
    const settingsObject = settings || {};
    if (settingsObject[settingKey]) return settingsObject[settingKey];
    return FragranceFinder.getTranslations(settingsObject)[translationKey] || '';
  };

  function supportsSession() {
    try {
      const testKey = '__ff_test__';
      window.sessionStorage.setItem(testKey, '1');
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (error) { return false; }
  }

  FragranceFinder.Store = function Store(persist) {
    this.persist = persist && supportsSession();
    this.memory = null;
  };

  FragranceFinder.Store.prototype.read = function () {
    if (!this.persist) return this.memory;
    try {
      const storedValue = window.sessionStorage.getItem(STORAGE_KEY);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) { return null; }
  };

  FragranceFinder.Store.prototype.write = function (state) {
    if (!this.persist) { this.memory = state; return; }
    try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
    catch (error) {}
  };

  FragranceFinder.Store.prototype.clear = function () {
    this.memory = null;
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
  };

  FragranceFinder.klaviyoTrack = function klaviyoTrack(config, eventName, properties) {
    if (!config || !config.enabled) return;
    const name = eventName || '';
    const email = properties && properties.$email;
    try {
      let klaviyo = window.klaviyo;
      if (klaviyo && typeof klaviyo.track === 'function') {
        if (email && typeof klaviyo.identify === 'function') klaviyo.identify({ $email: email });
        klaviyo.track(name, properties || {});
        return;
      }
      window.klaviyo = window.klaviyo || [];
      if (email) window.klaviyo.push(['identify', { $email: email }]);
      window.klaviyo.push(['track', name, properties || {}]);
    } catch (error) {}
  };

  // Mirrors snippets/fragrance-finder-locale-url.liquid, for the fallback paths
  // that are built here rather than server-side. The destinations that come
  // from settings are already prefixed by the time they reach us.
  FragranceFinder.localeUrl = function localeUrl(settings, path) {
    const url = typeof path === 'string' ? path.trim() : '';
    let root = (settings && settings.localeRoot) || '/';
    if (root !== '/' && root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    if (!url || root === '/' || url.charAt(0) !== '/') return url;
    // The trailing slash stops /france being treated as already carrying /fr.
    if (url === root || url.indexOf(root + '/') === 0) return url;
    return root + url;
  };

  // custom.gender is compared between products, never matched against a fixed
  // word, so the store can use MEN/WOMEN, Masculine/Feminine or anything else.
  // Lists are flattened by the catalog snippet before they reach us.
  FragranceFinder.normaliseGender = function normaliseGender(value) {
    if (value == null) return '';
    const text = Array.isArray(value) ? value.join(' ') : String(value);
    return text.trim().toLowerCase();
  };

  FragranceFinder.prefersReducedMotion = function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  FragranceFinder.normalizeRedirectUrl = function normalizeRedirectUrl(value, fallback) {
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value && typeof value === 'object') {
      const candidate = value.url || value.value || value.href;
      if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
    }
    if (value != null && window.location.search.indexOf('ff_debug') !== -1) {
      console.warn('[FragranceFinder] redirect URL was not a valid string — using fallback.', { value: value, fallback: fallback });
    }
    return fallback;
  };

  FragranceFinder.isPreviewDebugMode = function isPreviewDebugMode() {
    try { return new URLSearchParams(window.location.search).has('ff_debug'); }
    catch (error) { return window.location.search.indexOf('ff_debug') !== -1; }
  };

  FragranceFinder.previewResultsUrl = function previewResultsUrl() {
    try {
      let url = new URL(window.location.href);
      url.searchParams.set('view', 'fragrance-finder-results');
      return url.toString();
    } catch (error) {
      return window.location.href;
    }
  };

  FragranceFinder.fillPercent = function fillPercent(template, percent) {
    const clean = String(template == null ? '' : template).trim();
    const defaultText = "You're " + percent + '% through already!';
    if (!clean) return defaultText;
    if (/\{\{\s*progress\s*\}\}|\{\s*percent\s*\}/i.test(clean)) {
      return clean
        .replace(/\{\{\s*progress\s*\}\}/gi, percent)
        .replace(/\{\s*percent\s*\}/gi, percent);
    }
    if (/\d+\s*%/.test(clean)) {
      return clean.replace(/\d+(\s*)%/, percent + '$1%');
    }
    return defaultText;
  };

  // Product titles are stored in caps ("HALTANE"), which shouts mid-sentence.
  // Capitalising each word rather than only the first keeps two-part names right
  // — "DELINA EXCLUSIF" reads "Delina Exclusif", not "Delina exclusif".
  function capitaliseWords(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/(^|\s)(\S)/g, function (match, gap, letter) { return gap + letter.toUpperCase(); });
  }

  FragranceFinder.fillProfileIntro = function fillProfileIntro(template, product, answers) {
    const clean = String(template == null ? '' : template).trim();
    if (!clean) return '';
    answers = answers || {};
    // The recommended product's own olfactive family — NOT the visitor's answer.
    // The scoring winner often isn't the family they picked, so sourcing this from
    // an answer described the product with someone else's preference.
    //
    // Only the leading family reads as prose here: "a woody citrus spicy scent" is
    // a list, "a woody scent" is a sentence. The cards and the notes row still show
    // the full value — they read the metafield directly rather than this token.
    const notes = String((product && (product.cardNotes || product.notesSummary)) || '').toLowerCase();
    const leadingFamily = notes.match(/[a-zà-ÿ]+(?:-[a-zà-ÿ]+)*/);
    const scent = leadingFamily ? leadingFamily[0] : '';
    // The product name reads as a name; the scent family and answer descriptors
    // read as ordinary prose, so they stay lowercase inside the sentence.
    const filled = clean
      .replace(/\{\{\s*product\s*\}\}/gi, function () {
        return capitaliseWords((product && product.title) || '');
      })
      // Families like "ambery floral" need "an", so an article written directly in
      // front of the token is corrected to agree with whatever it resolves to.
      .replace(/\b(an?)(\s+)\{\{\s*scent\s*\}\}/gi, function (match, article, gap) {
        if (!scent) return '';
        const correct = /^[aeiou]/.test(scent) ? 'an' : 'a';
        const cased = article.charAt(0) === article.charAt(0).toUpperCase()
          ? correct.charAt(0).toUpperCase() + correct.slice(1)
          : correct;
        return cased + gap + scent;
      })
      .replace(/\{\{\s*scent\s*\}\}/gi, function () { return scent; })
      .replace(/\{\{\s*answer\s*:\s*(\d+)\s*\}\}/gi, function (match, questionNumber) {
        const answer = answers[String(parseInt(questionNumber, 10) - 1)];
        const value = answer && (answer.valueKey || answer.label);
        return value ? String(value).toLowerCase() : '';
      });
    return filled.replace(/\s{2,}/g, ' ').trim();
  };

  FragranceFinder.firstNotIn = function firstNotIn(list, exclude) {
    for (let index = 0; index < list.length; index++) {
      if (list[index] && exclude.indexOf(list[index]) === -1) return list[index];
    }
    return null;
  };

  FragranceFinder.cssEscape = function cssEscape(string) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(string);
    return String(string).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };
})(window.FragranceFinder = window.FragranceFinder || {});
